import React from 'react'
import { Link } from 'gatsby';
import { GTMEvents } from '../../../../lib/GTMevents';
import { IcoArrowRight, IcoHome } from '../../../../lib/svg';
import SliderInfo from './slider-info/slider-info';
import ListCard from './list-card/list-card';
import './ahorra-ya-banner.css'

const AhorraYaBanner = ({ scrollToSection }) => {
  return (
    <>
      <SliderInfo scrollToSection={scrollToSection} AhorroYaBannerBtn={GTMEvents.AhorroYaBannerBtn} />

      <div className={'ahorroYa-breadcrumb'} id="tabsContenido">
        <div className="container">
          <ul>
            <li onClick={() => {GTMEvents.AhorroYaBreadcrumBtn('Casa')}}>
              <Link to="/">
                <IcoHome height={14} />
              </Link>
              <IcoArrowRight height={14} stroke="#00A499" />
            </li>

            <li onClick={() => {GTMEvents.AhorroYaBreadcrumBtn('AhorroYa!')}}>
              <Link
                to="/aliados-comerciales/sobre-el-programa"
                onClick={() => window.location.reload()}
              >
                AhorroYa!
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="container">
        <ListCard scrollToSection={scrollToSection} AhorroYaSectionBtn={GTMEvents.AhorroYaSectionBtn} />
      </div>
    </>
  )
};

export default AhorraYaBanner;
